import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import ErrorBoundary from '../elementLibrary/ErrorBoundary';
import { AppStateContext, AppDispatchContext } from '../../context/AppContext';
import { usePageTitle } from '../../utils/hooks';

const CardContainer = styled.div`
    padding-left: 30px;
    padding-right: 30px;
`;

const CardComponentRoute = ({ children, name }) => {
    const { hasError, errorType, errorMsg, errorStatus } = useContext(
        AppStateContext,
    );
    const appDispatch = useContext(AppDispatchContext);
    usePageTitle({ title: `pageTitle$${name}` });

    return (
        <main role="main">
            <CardContainer>
                <ErrorBoundary
                    hasError={hasError}
                    errorType={errorType}
                    errorMsg={errorMsg}
                    errorStatus={errorStatus}
                    appDispatch={appDispatch}
                >
                    {children}
                </ErrorBoundary>
            </CardContainer>
        </main>
    );
};

CardComponentRoute.propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string,
};

CardComponentRoute.defaultProps = {
    name: '',
};

export default CardComponentRoute;
